// Allowance/deduction types are stored as snake_case ids (e.g. "eid_bonus")
// while the translation keys are camelCase ("eidBonus"). Resolve a stored
// type to its translated label, falling back to the raw id.
const TYPE_KEY_OVERRIDES = {
  sick_leave_25: "sickLeave",
};

const toCamel = (id) => id.replace(/_([a-z0-9])/g, (_, c) => c.toUpperCase());

export const adjustmentTypeLabel = (t, type) => {
  if (!type) return "";
  const candidates = [TYPE_KEY_OVERRIDES[type], type, toCamel(type)].filter(Boolean);
  for (const key of candidates) {
    const label = t(key);
    if (label && label !== key) return label;
  }
  return type;
};
